export class InvalidFieldError extends Error {
    constructor(msg: string) {
        super(msg)
    }
}
